var map = {
	"./asda/default-messages": 140,
	"./electrodeio/default-messages": 141,
	"./samsclub/default-messages": 142,
	"./walmart/default-messages": 143
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;



//////////////////
// WEBPACK FOOTER
// ./src/lang/tenants ^\.\/.*\/default\-messages$
// module id = 139
// module chunks = 0